// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"204da178","67":"6c2b8966","201":"90840e43","207":"7755d40b","237":"318b7591","259":"0ddca2e5","453":"ad17cdc0"}[chunkId] + ".chunk.js";
};